import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Accordion, Grid, Grid2 } from '@mui/material';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText, TextField, Typography, Card, CardContent, CardHeader } from '@mui/material';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { AccordionDetails, AccordionSummary } from '@mui/material';
import Swal from 'sweetalert2';
import SelectEventDate from './SelectEventDateForm';
import DateRangeSelector from './DateRangeSelector';
import MaterialPhoneInput from '../utils/MaterialPhoneInput';

function EventDetailsEditor({ eventsDetails, handleCloseDialog, editClient, editEvent, dressList, getDressListHandler, suitList, fetchEventDetails,
  editReservation, editWeddingPartner, dressReservations, getDressReservations, handleReqEventsError, getSuitListHandler, editXV, handleOpenDialog,
  editDress, editDude, editSuit, suitReservations }) {
  const [expanded, setExpanded] = useState('panel1');
  const [availableLongDresses, setAvailableLongDresses] = useState([]);
  const [availableShortDresses, setAvailableShortDresses] = useState([]);
  const [availableWeddingDresses, setAvailableWeddingDresses] = useState([]);
  const [availableSuits, setAvailableSuits] = useState([]);
  const [availableChildrenSuits, setAvailableChildrenSuits] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedDresses, setSelectedDresses] = useState(null);
  const [selectedSuits, setSelectedSuits] = useState(null);

  function formatDateForMySQL(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    // Ajustar para la zona horaria local para evitar diferencias UTC
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const filterAvailableDresses = (dressList) => {
    return dressList.filter(dress => {
      return !dressReservations.some(dressReservation => {
        const reservationStart = new Date(dressReservation.eventDateStart);
        const reservationEnd = new Date(dressReservation.eventDateEnd);
        const eventStart = new Date(eventsDetails.event.eventDateStart);
        const eventEnd = new Date(eventsDetails.event.eventDateEnd);

        const isDressReserved = dressReservation.dressID === dress.dressID;
        const isDress = dress.dressID > 3;

        const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
          (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
          (eventStart <= reservationStart && eventEnd >= reservationEnd);

        return isDressReserved && hasDateConflict || !isDress;
      });
    });
  };

  const filterDresses = (dressList) => {
    const shortDressesXV = dressList.filter(dress => dress.dressType === 'xv' && dress.dressSize === 'short');
    const longDressesXV = dressList.filter(dress => dress.dressType === 'xv' && dress.dressSize === 'long');
    const weddingDresses = dressList.filter(dress => dress.dressType === 'wedding');
    setAvailableLongDresses(filterAvailableDresses(longDressesXV));
    setAvailableShortDresses(filterAvailableDresses(shortDressesXV));
    setAvailableWeddingDresses(filterAvailableDresses(weddingDresses));
  };

  const filterAvailableSuits = (suitList) => {
    const reservedSuits = Array.isArray(suitReservations) ? suitReservations : [];
    const eventSuits = Array.isArray(eventsDetails?.suits) ? eventsDetails.suits : [];

    const firstFilter = suitList.filter(suit => {
      return !reservedSuits.some(suitReservation => {
        const reservationStart = new Date(suitReservation.eventDateStart);
        const reservationEnd = new Date(suitReservation.eventDateEnd);
        const eventStart = new Date(eventsDetails.event.eventDateStart);
        const eventEnd = new Date(eventsDetails.event.eventDateEnd);

        const isSuitReserved = suitReservation.suitID === suit.suitID;
        const isSuit = suit.suitID > 3;

        const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
          (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
          (eventStart <= reservationStart && eventEnd >= reservationEnd);

        return isSuitReserved && hasDateConflict || !isSuit;
      });
    });

    const secondFilter = firstFilter.filter(suit => {
      return !eventSuits.some(suitReservation => {
        const reservationStart = new Date(suitReservation.eventDateStart);
        const reservationEnd = new Date(suitReservation.eventDateEnd);
        const eventStart = new Date(eventsDetails.event.eventDateStart);
        const eventEnd = new Date(eventsDetails.event.eventDateEnd);

        const isSuitReserved = suitReservation.suitID === suit.suitID;
        const isSuit = suit.suitID > 3;

        const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
          (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
          (eventStart <= reservationStart && eventEnd >= reservationEnd);

        return isSuitReserved && hasDateConflict || !isSuit;
      });
    });

    return secondFilter;
  };

  const filterSuits = (suitList) => {
    const childrenSuits = suitList.filter(suit => suit.suitType === 'child');
    const adultSuits = suitList.filter(suit => suit.suitType === 'men');
    setAvailableChildrenSuits(filterAvailableSuits(childrenSuits));
    setAvailableSuits(filterAvailableSuits(adultSuits));
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const updateReservation = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonTextColor: '#fff',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });

      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const response = await fetch(`https://dprincess-training.servehttp.com/reservations/update-reservation/${eventsDetails.reservation.reservationID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(values)
        });

        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar la reservación, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('reservation'));
        }
        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }
      else {
        return handleOpenDialog('reservation');
      }
    } catch (error) {
      // Show error and close loading indicator
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('reservation'));
      handleReqEventsError(error);
    }
  };

  const updateXV = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const formattedValues = {
          ...values,
          birthday: formatDateForMySQL(values.birthday)
        };
        const response = await fetch(`https://dprincess-training.servehttp.com/xv/update-xv/${eventsDetails.XV.XVID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(formattedValues)
        });

        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información de la quinceañera, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('xv'));
        }

        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }

      else {
        return handleOpenDialog('xv');
      }

    } catch (error) {
      console.error("Error updating XV:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('xv'));
    }
  };

  const updateBirthdayDude = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const formattedValues = {
          ...values,
          birthday: formatDateForMySQL(values.birthday)
        };
        const response = await fetch(`https://dprincess-training.servehttp.com/birthday-dude/update-birthdaydude/${eventsDetails.birthdaydude.birthdayDudeID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(formattedValues)
        });

        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información del cumpleañero, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('birthdaydude'));
        }

        else {
          await Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#f759bb'
          });
          fetchEventDetails();
        }
      }

      else {
        return handleOpenDialog('birthdaydude');
      }

    } catch (error) {
      console.error("Error updating birthday dude:", error);
      Swal.close();
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('birthdaydude'));
    }
  };

  const updateWeddingPartner = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      })
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const formattedValues = {
          name: values.partnerName,
          wpCellphoneNumber: values.partnerCellphoneNumber,
          wpEmail: values.partnerEmail
        }
        const response = await fetch(`https://dprincess-training.servehttp.com/wedding-partner/update-wedding-partner/${eventsDetails.weddingpartner.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(formattedValues)
        });
        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información de la pareja, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('weddingpartner'));
        }
        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }
      else {
        return handleOpenDialog('weddingpartner');
      }
    } catch (error) {
      console.error("Error updating wedding partner:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('weddingpartner'));

    }
  };

  const updateClient = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const response = await fetch(`https://dprincess-training.servehttp.com/clients/update-client/${eventsDetails.client.clientID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(values)
        });

        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información del cliente, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('client'));
        }
        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }
      else {
        return handleOpenDialog('client');
      }
    } catch (error) {
      console.error("Error updating client:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('client'));
    }
  };

  const updateEvent = async (values) => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const formattedValues = {
          ...values,
          eventDateStart: formatDateForMySQL(values.eventDateStart),
          eventDateEnd: formatDateForMySQL(values.eventDateEnd)
        }
        const response = await fetch(`https://dprincess-training.servehttp.com/events/update-event/${eventsDetails.event.eventID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(formattedValues)
        });
        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información del evento, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('event'));
        }
        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }
    } catch (error) {
      console.error("Error updating event:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('event'));
    }
  };

  const handleDressValueChange = (type, index, values) => {
    setSelectedDresses(prev => {
      const updated = { ...prev };
      updated[type] = [...updated[type]];
      updated[type][index] = values;
      return updated;
    });
  };

  const handleSuitValueChange = (type, index, values) => {
    setSelectedSuits(prev => {
      const updated = { ...prev };
      updated[type] = [...(updated[type] || [])];
      updated[type][index] = values;
      return updated;
    });
  };

  const handleSaveAllDresses = async () => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const response = await fetch(`https://dprincess-training.servehttp.com/reservations/update-dress-reservation/${eventsDetails.event.eventID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(selectedDresses)
        });

        if (!response.ok) {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información de los vestidos reservados, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('dress'));
        }

        else {
          Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }

      else {
        return handleOpenDialog('dress');
      }

    } catch (error) {
      console.error("Error updating dress:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('dress'));
    }
  };

  const handleSaveAllSuits = async () => {
    try {
      handleCloseDialog();
      const confirmReq = await Swal.fire({
        title: 'Confirmar cambios',
        icon: 'question',
        text: '¿Estás seguro de que deseas guardar los cambios?',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d32f2f',
        confirmButtonText: 'Guardar cambios',
        confirmButtonColor: '#f759bb'
      });
      console.log("Form values:", selectedSuits);
      if (confirmReq.isConfirmed) {
        Swal.fire({
          title: 'Guardando cambios...',
          html: 'Por favor espera mientras se procesan los datos',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        const response = await fetch(`https://dprincess-training.servehttp.com/reservations/update-suit-reservation/${eventsDetails.event.eventID}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(selectedSuits)
        });

        if (!response.ok) {
          Swal.close();
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Error al actualizar información de los trajes reservados, por favor intenta de nuevo.'
          }).then(() => handleOpenDialog('suit'));
        }

        else {
          Swal.close();
          await Swal.fire({
            title: 'Cambios guardados',
            icon: 'success',
            text: 'Los cambios se han guardado exitosamente'
          });
          fetchEventDetails();
        }
      }

      else {
        return handleOpenDialog('suit');
      }

    } catch (error) {
      console.error("Error updating suit:", error);
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Ocurrió un error al procesar la solicitud'
      }).then(() => handleOpenDialog('suit'));
    }
  };

  const formatDateTo12Hour = (isoDateString) => {
    console.log('ISO date:', isoDateString);
    if (!isoDateString) return '';

    try {
      const date = new Date(isoDateString);

      // Check if date is valid before formatting
      if (isNaN(date.getTime())) {
        console.log('Invalid date:', isoDateString);
        return '';
      }

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      };

      return date.toLocaleString('es-MX', options);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };

  useEffect(() => {
    filterDresses(dressList);
    filterSuits(suitList);
    if (eventsDetails?.dresses) {
      setSelectedDresses(eventsDetails.dresses);
    }
    if (eventsDetails?.suits) {
      setSelectedSuits(eventsDetails.suits);
    }
  }, []);

  useEffect(() => {
    filterDresses(dressList);
  }, [dressList]);

  useEffect(() => {
    filterSuits(suitList);
  }, [suitList]);

  return (
    <React.Fragment>
      {/* Reservation Dialog */}
      {editReservation && (
        <Dialog open={editReservation} onClose={handleCloseDialog} sx={{ width: '100%' }} maxWidth="md" fullWidth>
          <DialogTitle>Modificar los detalles del evento</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  comboName: eventsDetails.reservation?.comboName,
                  shortDress: eventsDetails.dresses.shortDress.dressName,
                  shortDressID: eventsDetails.dresses.shortDress.dressID,
                  longDress: eventsDetails.dresses.longDress.dressName,
                  longDressID: eventsDetails.dresses.longDress.dressID,
                  confirmation: eventsDetails.reservation.confirmation,
                  shortDressReservation: eventsDetails.reservation.shortDress,
                  longDressReservation: eventsDetails.reservation.longDress
                }}
                validationSchema={Yup.object({
                  comboName: Yup.string().required('El nombre del combo es requerido'),
                  shortDress: Yup.string().required('El vestido corto es requerido'),
                  longDress: Yup.string().required('El vestido largo es requerido'),
                  confirmation: Yup.number().required('La confirmación es requerida'),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  updateReservation(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="reservationEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.comboName && Boolean(formik.errors.comboName)}>
                      <TextField id='comboName' name='comboName' variant='outlined' label='Nombre del combo' value={formik.values.comboName} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.comboName && Boolean(formik.errors.comboName)} />
                      {formik.touched.comboName && formik.errors.comboName && (
                        <FormHelperText error>{formik.errors.comboName}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="normal"
                      error={formik.touched.confirmation && Boolean(formik.errors.confirmation)}
                    >
                      <InputLabel id="confirmation-label">Confirmación de fecha</InputLabel>
                      <Select
                        labelId="confirmation-label"
                        id="confirmation"
                        name="confirmation"
                        value={formik.values.confirmation}
                        label="Confirmación de fecha"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        variant="outlined"
                      >
                        <MenuItem value={1}>Confirmado</MenuItem>
                        <MenuItem value={0}>Pendiente</MenuItem>
                      </Select>
                      {formik.touched.confirmation && formik.errors.confirmation && (
                        <FormHelperText error>{formik.errors.confirmation}</FormHelperText>
                      )}
                    </FormControl>
                    {eventsDetails.weddingpartner?.id ? null : (
                      <FormControl fullWidth margin='normal' error={formik.touched.shortDress && Boolean(formik.errors.shortDress)}>
                        <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                          <AccordionSummary
                            aria-controls="panel1d-content"
                            id="panel1d-header"
                            expandIcon={<ArrowForwardIosSharpIcon />}
                          >
                            <Typography component="span">Vestido corto: {formik.values.shortDress}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {availableShortDresses.length > 0 && (
                              <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                <Grid item xs={12}>
                                  <TextField
                                    label="Buscar vestido"
                                    variant="outlined"
                                    fullWidth
                                    value={search}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      setSearch(e.target.value);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </Grid>
                                {
                                  availableShortDresses
                                    .filter(dress =>
                                      dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                      (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                    )
                                    .map((dress) => (
                                      <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                        <Card
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            formik.setFieldValue('shortDress', dress.dressName);
                                            formik.setFieldValue('shortDressID', dress.dressID);
                                            setExpanded(false);
                                          }}
                                          sx={{
                                            cursor: "pointer",
                                            backgroundColor: dress.dressID === formik.values.shortDressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                          }}
                                        >
                                          <CardContent sx={{ height: "90px" }}>
                                            <Typography variant="h6">{dress.dressName}</Typography>
                                            <Typography variant="body2" color="textSecondary">
                                              Código: {dress.code}
                                            </Typography>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    ))
                                }
                              </Grid>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </FormControl>
                    )}
                    {eventsDetails.weddingpartner?.id ? null : (
                      <FormControl fullWidth margin='normal' error={formik.touched.longDress && Boolean(formik.errors.longDress)}>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
                          <AccordionSummary
                            aria-controls="panel2d-content"
                            id="panel2d-header"
                            expandIcon={<ArrowForwardIosSharpIcon />}
                          >
                            <Typography component="span">Vestido largo: {formik.values.longDress}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {availableLongDresses.length > 0 && (
                              <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                <Grid item xs={12}>
                                  <TextField
                                    label="Buscar vestido"
                                    variant="outlined"
                                    fullWidth
                                    value={search}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      setSearch(e.target.value);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </Grid>
                                {
                                  availableLongDresses
                                    .filter(dress =>
                                      dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                      (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                    )
                                    .map((dress) => (
                                      <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                        <Card
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            formik.setFieldValue('longDress', dress.dressName);
                                            formik.setFieldValue('longDressID', dress.dressID);
                                            setExpanded(false);
                                          }}
                                          sx={{
                                            cursor: "pointer",
                                            backgroundColor: dress.dressID === formik.values.shortDressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                          }}
                                        >
                                          <CardContent sx={{ height: "90px" }}>
                                            <Typography variant="h6">{dress.dressName}</Typography>
                                            <Typography variant="body2" color="textSecondary">
                                              Código: {dress.code}
                                            </Typography>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    ))
                                }
                              </Grid>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </FormControl>
                    )}
                    {eventsDetails.weddingpartner?.id ? (
                      <FormControl fullWidth margin='normal' error={formik.touched.longDress && Boolean(formik.errors.longDress)}>
                        <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
                          <AccordionSummary
                            aria-controls="panel2d-content"
                            id="panel2d-header"
                            expandIcon={<ArrowForwardIosSharpIcon />}
                          >
                            <Typography component="span">Vestido largo: {formik.values.longDress}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {availableWeddingDresses.length > 0 && (
                              <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                <Grid item xs={12}>
                                  <TextField
                                    label="Buscar vestido"
                                    variant="outlined"
                                    fullWidth
                                    value={search}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      setSearch(e.target.value);
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </Grid>
                                {
                                  availableWeddingDresses
                                    .filter(dress =>
                                      dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                      (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                    )
                                    .map((dress) => (
                                      <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                        <Card
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            formik.setFieldValue('longDress', dress.dressName);
                                            formik.setFieldValue('longDressID', dress.dressID);
                                            setExpanded(false);
                                          }}
                                          sx={{
                                            cursor: "pointer",
                                            backgroundColor: dress.dressID === formik.values.shortDressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                          }}
                                        >
                                          <CardContent sx={{ height: "90px" }}>
                                            <Typography variant="h6">{dress.dressName}</Typography>
                                            <Typography variant="body2" color="textSecondary">
                                              Código: {dress.code}
                                            </Typography>
                                          </CardContent>
                                        </Card>
                                      </Grid>
                                    ))
                                }
                              </Grid>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </FormControl>
                    ) : null}
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="reservationEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Client Dialog */}
      {editClient && (
        <Dialog open={editClient} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar los detalles del cliente</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  clientName: eventsDetails.client.clientName,
                  phoneNumber: eventsDetails.client.phoneNumber,
                  clientEmail: eventsDetails.client.clientEmail,
                  address: eventsDetails.client.address,
                  cellphoneNumber: eventsDetails.client.cellphoneNumber
                }}
                validationSchema={Yup.object({
                  clientName: Yup.string().required('El nombre del cliente es requerido'),
                  cellphoneNumber: Yup.string().required('El celular del cliente es requerido'),
                  clientEmail: Yup.string().email('Correo electrónico inválido').required('El correo electrónico del cliente es requerido')
                })}
                onSubmit={(values, { setSubmitting }) => {
                  updateClient(values);
                  console.log(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="clientEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.clientName && Boolean(formik.errors.clientName)}>
                      <TextField id='clientName' name='clientName' variant='outlined' label='Nombre del cliente' value={formik.values.clientName} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.clientName && Boolean(formik.errors.clientName)} />
                      {formik.touched.clientName && formik.errors.clientName && (
                        <FormHelperText error>{formik.errors.clientName}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}>
                      <Field name="phoneNumber">
                        {({ field, form, meta }) => (
                          <MaterialPhoneInput
                            label="Teléfono del cliente"
                            name={field.name}
                            value={field.value}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                            onChange={(phone) => {
                              form.setFieldValue(field.name, phone);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.clientEmail && Boolean(formik.errors.clientEmail)}>
                      <TextField id='clientEmail' name='clientEmail' variant='outlined' label='Correo electrónico del cliente' value={formik.values.clientEmail} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.clientEmail && Boolean(formik.errors.clientEmail)} />
                      {formik.touched.clientEmail && formik.errors.clientEmail && (
                        <FormHelperText error>{formik.errors.clientEmail}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.address && Boolean(formik.errors.address)}>
                      <TextField id='address' name='address' variant='outlined' label='Dirección del cliente' value={formik.values.address} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.address && Boolean(formik.errors.address)} />
                      {formik.touched.address && formik.errors.address && (
                        <FormHelperText error>{formik.errors.address}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.cellphoneNumber && Boolean(formik.errors.cellphoneNumber)}>
                      <Field name="cellphoneNumber">
                        {({ field, form, meta }) => (
                          <MaterialPhoneInput
                            label="Celular del cliente"
                            name={field.name}
                            value={field.value}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                            onChange={(phone) => {
                              form.setFieldValue(field.name, phone);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="clientEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Quinceañera Dialog */}
      {editXV && (
        <Dialog open={editXV} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar los detalles de la quinceañera</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  XVName: eventsDetails.XV.XVName,
                  XVEmail: eventsDetails.XV.XVEmail,
                  XVCellphoneNumber: eventsDetails.XV.XVCellphoneNumber,
                  birthday: eventsDetails.XV.birthday?.slice(0, 10) || ''
                }}
                validationSchema={Yup.object({
                  XVName: Yup.string().required('El nombre de la quinceañera es requerido'),
                  XVEmail: Yup.string().email('Correo electrónico inválido').required('El correo electrónico de la quinceañera es requerido'),
                  birthday: Yup.date().required('La fecha de nacimiento de la quinceañera es requerida')
                })}
                onSubmit={(values, { setSubmitting }) => {
                  console.log(values);
                  updateXV(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="XVEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.XVName && Boolean(formik.errors.XVName)}>
                      <TextField id='XVName' name='XVName' variant='outlined' label='Nombre de la quinceañera' value={formik.values.XVName} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.XVName && Boolean(formik.errors.XVName)} />
                      {formik.touched.XVName && formik.errors.XVName && (
                        <FormHelperText error>{formik.errors.XVName}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.XVEmail && Boolean(formik.errors.XVEmail)}>
                      <TextField id='XVEmail' name='XVEmail' variant='outlined' label='Email de la quinceañera' value={formik.values.XVEmail} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.XVEmail && Boolean(formik.errors.XVEmail)} />
                      {formik.touched.XVEmail && formik.errors.XVEmail && (
                        <FormHelperText error>{formik.errors.XVEmail}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.XVCellphoneNumber && Boolean(formik.errors.XVCellphoneNumber)}>
                      <Field name="XVCellphoneNumber">
                        {({ field, form, meta }) => (
                          <MaterialPhoneInput
                            label="Celular de la quinceañera"
                            name={field.name}
                            value={field.value}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                            onChange={(phone) => {
                              form.setFieldValue(field.name, phone);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.birthday && Boolean(formik.errors.birthday)}>
                      <TextField id='birthday' name='birthday' variant='outlined' label='Fecha de nacimiento de la quinceañera' value={formik.values.birthday}
                        type='date' onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.birthday && Boolean(formik.errors.birthday)}
                        InputLabelProps={{ shrink: true }}
                      />
                      {formik.touched.birthday && formik.errors.birthday && (
                        <FormHelperText error>{formik.errors.birthday}</FormHelperText>
                      )}
                    </FormControl>
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="XVEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Cumpleañero Dialog */}
      {editDude && (
        <Dialog open={editDude} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar los detalles del cumpleañero</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  name: eventsDetails.birthdaydude.name,
                  email: eventsDetails.birthdaydude.email,
                  cellphoneNumber: eventsDetails.birthdaydude.cellphoneNumber,
                  birthday: eventsDetails.birthdaydude.birthday?.slice(0, 10) || ''
                }}
                validationSchema={Yup.object({
                  name: Yup.string().required('El nombre del cumpleañero es requerido'),
                  email: Yup.string().email('Correo electrónico inválido'),
                  birthday: Yup.date().required('La fecha de nacimiento del cumpleañero es requerida')
                })}
                onSubmit={(values, { setSubmitting }) => {
                  console.log(values);
                  updateBirthdayDude(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="DudeEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.name && Boolean(formik.errors.name)}>
                      <TextField id='name' name='name' variant='outlined' label='Nombre del cumpleañero' value={formik.values.name} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.name && Boolean(formik.errors.name)} />
                      {formik.touched.name && formik.errors.name && (
                        <FormHelperText error>{formik.errors.name}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.email && Boolean(formik.errors.email)}>
                      <TextField id='email' name='email' variant='outlined' label='Email del cumpleañero' value={formik.values.email} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.email && Boolean(formik.errors.email)} />
                      {formik.touched.email && formik.errors.email && (
                        <FormHelperText error>{formik.errors.email}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.cellphoneNumber && Boolean(formik.errors.cellphoneNumber)}>
                      <Field name="cellphoneNumber">
                        {({ field, form, meta }) => (
                          <MaterialPhoneInput
                            label="Celular del cumpleañero"
                            name={field.name}
                            value={field.value}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                            onChange={(phone) => {
                              form.setFieldValue(field.name, phone);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.birthday && Boolean(formik.errors.birthday)}>
                      <TextField id='birthday' name='birthday' variant='outlined' label='Fecha de nacimiento de la quinceañera' value={formik.values.birthday}
                        type='date' onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.birthday && Boolean(formik.errors.birthday)}
                        InputLabelProps={{ shrink: true }}
                      />
                      {formik.touched.birthday && formik.errors.birthday && (
                        <FormHelperText error>{formik.errors.birthday}</FormHelperText>
                      )}
                    </FormControl>
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="DudeEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#3a3535ff' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Wedding Partner Dialog */}
      {editWeddingPartner && (
        <Dialog open={editWeddingPartner} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar los detalles de la pareja</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  partnerName: eventsDetails.weddingpartner?.name,
                  partnerEmail: eventsDetails.weddingpartner?.wpEmail,
                  partnerCellphoneNumber: eventsDetails.weddingpartner.wpCellphoneNumber
                }}
                validationSchema={Yup.object({
                  partnerName: Yup.string().required('El nombre de la pareja es requerido'),
                  partnerEmail: Yup.string().email('Correo electrónico inválido').required('El correo electrónico de la pareja es requerido'),
                  partnerCellphoneNumber: Yup.string().required('El celular de la pareja es requerido')
                })}
                onSubmit={(values, { setSubmitting }) => {
                  console.log(values);
                  updateWeddingPartner(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="weddingPartnerEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.partnerName && Boolean(formik.errors.partnerName)}>
                      <TextField id='partnerName' name='partnerName' variant='outlined' label='Nombre de la pareja' value={formik.values.partnerName} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.partnerName && Boolean(formik.errors.partnerName)} />
                      {formik.touched.partnerName && formik.errors.partnerName && (
                        <FormHelperText error>{formik.errors.partnerName}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.partnerEmail && Boolean(formik.errors.partnerEmail)}>
                      <TextField id='partnerEmail' name='partnerEmail' variant='outlined' label='Email de la pareja' value={formik.values.partnerEmail} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.partnerEmail && Boolean(formik.errors.partnerEmail)} />
                      {formik.touched.partnerEmail && formik.errors.partnerEmail && (
                        <FormHelperText error>{formik.errors.partnerEmail}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.partnerCellphoneNumber && Boolean(formik.errors.partnerCellphoneNumber)}>
                      <Field name="partnerCellphoneNumber">
                        {({ field, form, meta }) => (
                          <MaterialPhoneInput
                            label="Celular de la pareja"
                            name={field.name}
                            value={field.value}
                            error={meta.touched && Boolean(meta.error)}
                            helperText={meta.touched && meta.error}
                            color={meta.error ? 'error' : (!meta.error && meta.touched ? 'success' : undefined)}
                            onChange={(phone) => {
                              form.setFieldValue(field.name, phone);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      </Field>
                    </FormControl>
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="weddingPartnerEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Event Dialog */}
      {editEvent && (
        <Dialog open={editEvent} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar los detalles del evento</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Formik
                initialValues={{
                  eventDateStart: eventsDetails.event.eventDateStart,
                  eventDateEnd: eventsDetails.event.eventDateEnd,
                  eventLocation: eventsDetails.event.eventLocation,
                  eventDescription: eventsDetails.event.eventDescription,
                  eventType: eventsDetails.event.eventType,
                  eventTitle: eventsDetails.event.eventTitle
                }}
                validationSchema={Yup.object({
                  eventDateStart: Yup.date().required('La fecha de inicio del evento es requerida'),
                  eventDateEnd: Yup.date().required('La fecha de fin del evento es requerida'),
                  eventLocation: Yup.string().required('La ubicación del evento es requerida'),
                  eventDescription: Yup.string().required('La descripción del evento es requerida')
                })}
                onSubmit={(values, { setSubmitting }) => {
                  console.log(values);
                  updateEvent(values);
                  setSubmitting(false);
                }}
              >
                {formik => (
                  <form id="eventEditForm" onSubmit={formik.handleSubmit}>
                    <FormControl fullWidth margin='normal' error={formik.touched.eventTitle && Boolean(formik.errors.eventTitle)}>
                      <TextField id='eventTitle' name='eventTitle' variant='outlined' label='Título del evento' value={formik.values.eventTitle} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.eventTitle && Boolean(formik.errors.eventTitle)} />
                      {formik.touched.eventTitle && formik.errors.eventTitle && (
                        <FormHelperText error>{formik.errors.eventTitle}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.eventLocation && Boolean(formik.errors.eventLocation)}>
                      <TextField id='eventLocation' name='eventLocation' variant='outlined' label='Ubicación del evento' value={formik.values.eventLocation} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.eventLocation && Boolean(formik.errors.eventLocation)} />
                      {formik.touched.eventLocation && formik.errors.eventLocation && (
                        <FormHelperText error>{formik.errors.eventLocation}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl fullWidth margin='normal' error={formik.touched.eventDescription && Boolean(formik.errors.eventDescription)}>
                      <TextField id='eventDescription' name='eventDescription' variant='outlined' label='Descripción del evento' value={formik.values.eventDescription} onChange={formik.handleChange}
                        onBlur={formik.handleBlur} error={formik.touched.eventDescription && Boolean(formik.errors.eventDescription)} />
                      {formik.touched.eventDescription && formik.errors.eventDescription && (
                        <FormHelperText error>{formik.errors.eventDescription}</FormHelperText>
                      )}
                    </FormControl>
                    {
                      eventsDetails.event.eventType === 'rental'
                        ? (
                          <FormControl fullWidth margin='normal'>
                            <Grid2 container spacing={1} fullWidth pt={1} sx={{ display: 'flex', alignItems: 'center' }}>
                              <DateRangeSelector
                                typeOfEvent={formik.values.eventType}
                                handleEventDate={(date) => {
                                  formik.setFieldValue('eventDateStart', date.start);
                                  formik.setFieldValue('eventDateEnd', date.end);
                                }}
                              />
                            </Grid2>
                          </FormControl>
                        )
                        : (
                          <FormControl fullWidth margin='normal'>
                            <Grid2 container spacing={1} fullWidth pt={1} sx={{ display: 'flex', alignItems: 'center' }}>
                              <Typography sx={{ color: 'black' }}>Cambiar fecha del evento</Typography>
                              <SelectEventDate eventDate={{ eventDateStart: formik.values.eventDateStart, eventDateEnd: formik.values.eventDateEnd }} typeOfEvent={formik.values.eventType} showDateTimePicker={true}
                                labelName={'Fecha del evento'} handleEventDate={(date) => formik.setFieldValue('eventDateStart', date.start) && formik.setFieldValue('eventDateEnd', date.end)} />
                            </Grid2>
                            <Grid2 container spacing={10} fullWidth pt={3}>
                              <TextField id='eventDateStart' name='eventDateStart' variant='outlined' label='Fecha de inicio del evento' InputLabelProps={{ shrink: true }}
                                value={formatDateTo12Hour(formik.values.eventDateStart)} onChange={formik.handleChange} disabled />
                              <TextField id='eventDateEnd' name='eventDateEnd' variant='outlined' label='Fecha de finalización' InputLabelProps={{ shrink: true }}
                                value={formatDateTo12Hour(formik.values.eventDateEnd)} onChange={formik.handleChange} disabled />
                            </Grid2>
                          </FormControl>
                        )
                    }
                  </form>
                )}
              </Formik>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' form="eventEditForm" variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }}>Guardar cambios</Button>
            <Button onClick={handleCloseDialog} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog >
      )}

      {/* Dresses Dialog */}
      {editDress && (
        <Dialog open={editDress} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar la selección de vestidos</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Card sx={{ marginBottom: 2 }}>
                <CardHeader title="Vestidos seleccionados" subheader="Selecciona los vestidos largos para el evento" />
                <CardContent>
                  {
                    eventsDetails?.dresses?.longDress.map((dress, index) => (
                      dress.dressType === 'xv' ? (
                        <Formik
                          initialValues={{
                            dressName: dress.dressName,
                            dressID: dress.dressID,
                            code: dress.code,
                            dressType: dress.dressType,
                            dressSize: dress.dressSize
                          }}
                          validationSchema={Yup.object({
                            dressName: Yup.string().required('El vestido largo es requerido')
                          })}
                          onSubmit={(values, { setSubmitting }) => {
                            handleDressValueChange('longDress', index, values);
                            setSubmitting(false);
                          }}
                        >
                          {formik => (
                            <form id={`longDressReservationEditForm${index}`} onSubmit={formik.handleSubmit}>
                              <FormControl fullWidth margin='normal' error={formik.touched.dressName && Boolean(formik.errors.dressName)}>
                                <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} >
                                  <AccordionSummary
                                    aria-controls="panel1d-content"
                                    id="panel1d-header"
                                    expandIcon={<ArrowForwardIosSharpIcon />}
                                  >
                                    <Typography component="span">Vestido largo ({index + 1}): {formik.values.dressName}</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    {availableLongDresses.length > 0 && (
                                      <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                        <Grid item xs={12}>
                                          <TextField
                                            label="Buscar vestido"
                                            variant="outlined"
                                            fullWidth
                                            value={search}
                                            onChange={(e) => {
                                              e.stopPropagation();
                                              setSearch(e.target.value);
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                          />
                                        </Grid>
                                        {
                                          availableLongDresses
                                            .filter(dress =>
                                              dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                              (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                            )
                                            .map((dress) => (
                                              <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                                <Card
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    const previousDressID = formik.values.dressID;
                                                    formik.setFieldValue('dressName', dress.dressName);
                                                    formik.setFieldValue('dressID', dress.dressID);
                                                    formik.setFieldValue('code', dress.code);
                                                    formik.setFieldValue('dressType', dress.dressType);
                                                    formik.setFieldValue('dressSize', dress.dressSize);
                                                    const newValues = {
                                                      dressName: dress.dressName,
                                                      dressID: dress.dressID,
                                                      code: dress.code,
                                                      dressType: dress.dressType,
                                                      dressSize: dress.dressSize,
                                                      prevDressID: previousDressID
                                                    };
                                                    handleDressValueChange('longDress', index, newValues);
                                                    setExpanded(false);
                                                  }}
                                                  sx={{
                                                    cursor: "pointer",
                                                    backgroundColor: dress.dressID === formik.values.dressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                                  }}
                                                >
                                                  <CardContent sx={{ height: "90px" }}>
                                                    <Typography variant="h6">{dress.dressName}</Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                      Código: {dress.code}
                                                    </Typography>
                                                  </CardContent>
                                                </Card>
                                              </Grid>
                                            ))
                                        }
                                      </Grid>
                                    )}
                                  </AccordionDetails>
                                </Accordion>
                              </FormControl>
                            </form>
                          )}
                        </Formik>
                      )
                        : (
                          <Formik
                            initialValues={{
                              dressName: dress.dressName,
                              dressID: dress.dressID,
                              code: dress.code,
                              dressType: dress.dressType,
                              dressSize: dress.dressSize
                            }}
                            validationSchema={Yup.object({
                              dressName: Yup.string().required('El vestido largo es requerido')
                            })}
                            onSubmit={(values, { setSubmitting }) => {
                              handleDressValueChange('longDress', index, values);
                              setSubmitting(false);
                            }}
                          >
                            {formik => (
                              <form id={`longDressReservationEditForm${index}`} onSubmit={formik.handleSubmit}>
                                <FormControl fullWidth margin='normal' error={formik.touched.dressName && Boolean(formik.errors.dressName)}>
                                  <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} >
                                    <AccordionSummary
                                      aria-controls="panel1d-content"
                                      id="panel1d-header"
                                      expandIcon={<ArrowForwardIosSharpIcon />}
                                    >
                                      <Typography component="span">Vestido de boda ({index + 1}): {formik.values.dressName}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {availableWeddingDresses.length > 0 && (
                                        <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                          <Grid item xs={12}>
                                            <TextField
                                              label="Buscar vestido"
                                              variant="outlined"
                                              fullWidth
                                              value={search}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                setSearch(e.target.value);
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            />
                                          </Grid>
                                          {
                                            availableWeddingDresses
                                              .filter(dress =>
                                                dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                                (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                              )
                                              .map((dress) => (
                                                <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                                  <Card
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const previousDressID = formik.values.dressID;
                                                      formik.setFieldValue('dressName', dress.dressName);
                                                      formik.setFieldValue('dressID', dress.dressID);
                                                      formik.setFieldValue('code', dress.code);
                                                      formik.setFieldValue('dressType', dress.dressType);
                                                      formik.setFieldValue('dressSize', dress.dressSize);
                                                      setExpanded(false);
                                                      const newValues = {
                                                        dressName: dress.dressName,
                                                        dressID: dress.dressID,
                                                        code: dress.code,
                                                        dressType: dress.dressType,
                                                        dressSize: dress.dressSize,
                                                        prevDressID: previousDressID
                                                      };
                                                      handleDressValueChange('longDress', index, newValues);
                                                      setExpanded(false);
                                                    }}
                                                    sx={{
                                                      cursor: "pointer",
                                                      backgroundColor: dress.dressID === formik.values.dressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                                    }}
                                                  >
                                                    <CardContent sx={{ height: "90px" }}>
                                                      <Typography variant="h6">{dress.dressName}</Typography>
                                                      <Typography variant="body2" color="textSecondary">
                                                        Código: {dress.code}
                                                      </Typography>
                                                    </CardContent>
                                                  </Card>
                                                </Grid>
                                              ))
                                          }
                                        </Grid>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </FormControl>
                              </form>
                            )}
                          </Formik>
                        )
                    ))
                  }
                </CardContent>
              </Card>
              {
                eventsDetails?.dresses?.shortDress.map((dress, index) => (
                  dress.dressType === 'xv' && (
                    <Card sx={{ marginBottom: 2 }}>
                      <CardHeader title="Vestidos cortos seleccionados" subheader="Selecciona los vestidos cortos para el evento" />
                      <CardContent>
                        <Formik
                          initialValues={{
                            dressName: dress.dressName,
                            dressID: dress.dressID,
                            code: dress.code,
                            dressType: dress.dressType,
                            dressSize: dress.dressSize
                          }}
                          validationSchema={Yup.object({
                            dressName: Yup.string().required('El vestido Corto es requerido')
                          })}
                          onSubmit={(values, { setSubmitting }) => {
                            handleDressValueChange('shortDress', index, values);
                            setSubmitting(false);
                          }}
                          enableReinitialize
                        >
                          {formik => (
                            <form id={`shortDressReservationEditForm${index}`} onSubmit={formik.handleSubmit}>
                              <FormControl fullWidth margin='normal' error={formik.touched.dressName && Boolean(formik.errors.dressName)}>
                                <Accordion expanded={expanded === `panelS${index + 1}`} onChange={handleChange(`panelS${index + 1}`)} >
                                  <AccordionSummary
                                    aria-controls="panel1d-content"
                                    id="panel1d-header"
                                    expandIcon={<ArrowForwardIosSharpIcon />}
                                  >
                                    <Typography component="span">Vestido corto ({index + 1}): {formik.values.dressName}</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    {availableShortDresses.length > 0 && (
                                      <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                        <Grid item xs={12}>
                                          <TextField
                                            label="Buscar vestido por nombre o código"
                                            variant="outlined"
                                            fullWidth
                                            value={search}
                                            onChange={(e) => {
                                              e.stopPropagation();
                                              setSearch(e.target.value);
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                          />
                                        </Grid>
                                        {
                                          availableShortDresses
                                            .filter(dress =>
                                              dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
                                              (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
                                            )
                                            .map((dress) => (
                                              <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                                                <Card
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    const previousDressID = formik.values.dressID;
                                                    formik.setFieldValue('dressName', dress.dressName);
                                                    formik.setFieldValue('dressID', dress.dressID);
                                                    formik.setFieldValue('code', dress.code);
                                                    formik.setFieldValue('dressType', dress.dressType);
                                                    formik.setFieldValue('dressSize', dress.dressSize);
                                                    const newValues = {
                                                      dressName: dress.dressName,
                                                      dressID: dress.dressID,
                                                      code: dress.code,
                                                      dressType: dress.dressType,
                                                      dressSize: dress.dressSize,
                                                      prevDressID: previousDressID
                                                    };
                                                    handleDressValueChange('shortDress', index, newValues);
                                                    setExpanded(false);
                                                  }}
                                                  sx={{
                                                    cursor: "pointer",
                                                    backgroundColor: dress.dressID === formik.values.dressID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                                  }}
                                                >
                                                  <CardContent sx={{ height: "90px" }}>
                                                    <Typography variant="h6">{dress.dressName}</Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                      Código: {dress.code}
                                                    </Typography>
                                                  </CardContent>
                                                </Card>
                                              </Grid>
                                            ))
                                        }
                                      </Grid>
                                    )}
                                  </AccordionDetails>
                                </Accordion>
                              </FormControl>
                            </form>
                          )}
                        </Formik>
                      </CardContent>
                    </Card>
                  )
                ))
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }} onClick={handleSaveAllDresses}>Guardar cambios</Button>
            <Button onClick={() => { setSelectedDresses(eventsDetails.dresses); handleCloseDialog() }} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Suit Dialog */}
      {editSuit && (
        <Dialog open={editSuit} onClose={handleCloseDialog} maxWidth='md' fullWidth>
          <DialogTitle>Modificar la selección de trajes</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Card sx={{ marginBottom: 2 }}>
                <CardHeader title="Trajes seleccionados" subheader="Selecciona los trajes largos para el evento" />
                <CardContent>
                  {
                    eventsDetails?.suits?.map((suit, index) => (
                      suit.suitType === 'men' ? (
                        <Formik
                          initialValues={{
                            suitName: suit.suitName,
                            suitID: suit.suitID,
                            code: suit.code,
                            suitType: suit.suitType,
                            suitSize: suit.suitSize
                          }}
                          validationSchema={Yup.object({
                            suitName: Yup.string().required('El traje de hombre es requerido')
                          })}
                          onSubmit={(values, { setSubmitting }) => {
                            handleSuitValueChange('men', index, values);
                            setSubmitting(false);
                          }}
                        >
                          {formik => (
                            <form id={`menSuitReservationEditForm${index}`} onSubmit={formik.handleSubmit}>
                              <FormControl fullWidth margin='normal' error={formik.touched.suitName && Boolean(formik.errors.suitName)}>
                                <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} >
                                  <AccordionSummary
                                    aria-controls="panel1d-content"
                                    id="panel1d-header"
                                    expandIcon={<ArrowForwardIosSharpIcon />}
                                  >
                                    <Typography component="span">Traje de hombre ({index + 1}): {formik.values.suitName}</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    {availableSuits.length > 0 && (
                                      <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                        <Grid item xs={12}>
                                          <TextField
                                            label="Buscar trajes de hombre"
                                            variant="outlined"
                                            fullWidth
                                            value={search}
                                            onChange={(e) => {
                                              e.stopPropagation();
                                              setSearch(e.target.value);
                                            }}
                                            onClick={(e) => e.stopPropagation()}
                                          />
                                        </Grid>
                                        {
                                          availableSuits
                                            .filter(suit =>
                                              suit.suitName.toLowerCase().includes(search.toLowerCase()) ||
                                              (suit.code && suit.code.toLowerCase().includes(search.toLowerCase()))
                                            )
                                            .map((suit) => (
                                              <Grid item xs={12} sm={6} md={4} key={suit.suitID}>
                                                <Card
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    const previousSuitID = formik.values.suitID;
                                                    formik.setFieldValue('suitName', suit.suitName);
                                                    formik.setFieldValue('suitID', suit.suitID);
                                                    formik.setFieldValue('code', suit.code);
                                                    formik.setFieldValue('suitType', suit.suitType);
                                                    formik.setFieldValue('suitSize', suit.suitSize);
                                                    const newValues = {
                                                      suitName: suit.suitName,
                                                      suitID: suit.suitID,
                                                      code: suit.code,
                                                      suitType: suit.suitType,
                                                      suitSize: suit.suitSize,
                                                      prevSuitID: previousSuitID
                                                    };
                                                    handleSuitValueChange('men', index, newValues);
                                                    setExpanded(false);
                                                  }}
                                                  sx={{
                                                    cursor: "pointer",
                                                    backgroundColor: suit.suitID === formik.values.suitID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                                  }}
                                                >
                                                  <CardContent sx={{ height: "90px" }}>
                                                    <Typography variant="h6">{suit.suitName}</Typography>
                                                    <Typography variant="body2" color="textSecondary">
                                                      Código: {suit.code}
                                                    </Typography>
                                                  </CardContent>
                                                </Card>
                                              </Grid>
                                            ))
                                        }
                                      </Grid>
                                    )}
                                  </AccordionDetails>
                                </Accordion>
                              </FormControl>
                            </form>
                          )}
                        </Formik>
                      )
                        : (
                          <Formik
                            initialValues={{
                              suitName: suit.suitName,
                              suitID: suit.suitID,
                              code: suit.code,
                              suitType: suit.suitType,
                              suitSize: suit.suitSize
                            }}
                            validationSchema={Yup.object({
                              suitName: Yup.string().required('El traje de niño es requerido')
                            })}
                            onSubmit={(values, { setSubmitting }) => {
                              handleSuitValueChange('child', index, values);
                              setSubmitting(false);
                            }}
                          >
                            {formik => (
                              <form id={`childSuitReservationEditForm${index}`} onSubmit={formik.handleSubmit}>
                                <FormControl fullWidth margin='normal' error={formik.touched.suitName && Boolean(formik.errors.suitName)}>
                                  <Accordion expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} >
                                    <AccordionSummary
                                      aria-controls="panel1d-content"
                                      id="panel1d-header"
                                      expandIcon={<ArrowForwardIosSharpIcon />}
                                    >
                                      <Typography component="span">Traje de niño ({index + 1}): {formik.values.suitName}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {availableChildrenSuits.length > 0 && (
                                        <Grid container spacing={2} sx={{ marginTop: 0 }}>
                                          <Grid item xs={12}>
                                            <TextField
                                              label="Buscar trajes de niño"
                                              variant="outlined"
                                              fullWidth
                                              value={search}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                setSearch(e.target.value);
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            />
                                          </Grid>
                                          {
                                            availableChildrenSuits
                                              .filter(suit =>
                                                suit.suitName.toLowerCase().includes(search.toLowerCase()) ||
                                                (suit.code && suit.code.toLowerCase().includes(search.toLowerCase()))
                                              )
                                              .map((suit) => (
                                                <Grid item xs={12} sm={6} md={4} key={suit.suitID}>
                                                  <Card
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      const previousSuitID = formik.values.suitID;
                                                      formik.setFieldValue('suitName', suit.suitName);
                                                      formik.setFieldValue('suitID', suit.suitID);
                                                      formik.setFieldValue('code', suit.code);
                                                      formik.setFieldValue('suitType', suit.suitType);
                                                      formik.setFieldValue('suitSize', suit.suitSize);
                                                      setExpanded(false);
                                                      const newValues = {
                                                        suitName: suit.suitName,
                                                        suitID: suit.suitID,
                                                        code: suit.code,
                                                        suitType: suit.suitType,
                                                        suitSize: suit.suitSize,
                                                        prevSuitID: previousSuitID
                                                      };
                                                      handleSuitValueChange('child', index, newValues);
                                                      setExpanded(false);
                                                    }}
                                                    sx={{
                                                      cursor: "pointer",
                                                      backgroundColor: suit.suitID === formik.values.suitID ? 'rgba(30, 255, 0, 0.21)' : "white",
                                                    }}
                                                  >
                                                    <CardContent sx={{ height: "90px" }}>
                                                      <Typography variant="h6">{suit.suitName}</Typography>
                                                      <Typography variant="body2" color="textSecondary">
                                                        Código: {suit.code}
                                                      </Typography>
                                                    </CardContent>
                                                  </Card>
                                                </Grid>
                                              ))
                                          }
                                        </Grid>
                                      )}
                                    </AccordionDetails>
                                  </Accordion>
                                </FormControl>
                              </form>
                            )}
                          </Formik>
                        )
                    ))
                  }
                </CardContent>
              </Card>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button type='submit' variant='contained' sx={{ color: '#fff', backgroundColor: '#f759bb' }} onClick={handleSaveAllSuits}>Guardar cambios</Button>
            <Button onClick={() => { setSelectedSuits(eventsDetails.suits); handleCloseDialog() }} sx={{ color: '#fff', bgcolor: '#d32f2f' }}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment >
  )
}

export default EventDetailsEditor